import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import type { DateRange } from 'moment-range';

import { Form } from '@site-mate/dashpivot-shared-library';

import { ChartSettings } from 'app/shared/model/charts/chart-settings.model';
import { ChartUtilsService } from 'app/shared/service/chart-utils.service';

@Injectable()
export class FrequencyCumulativeBarChartDataParser {
  constructor(private readonly chartUtilsService: ChartUtilsService) {}

  // TODO: this should be pulled to a web worker
  public parseForms(forms: Form[], chart: ChartSettings, dateRange: DateRange) {
    const data = this.chartUtilsService.populateDates(chart.dateUnit, dateRange);

    forms.forEach((form) => {
      const date = this.chartUtilsService.getFormDate(chart, form);
      const groupName = this.chartUtilsService.getGroupNameForRow(form, chart, null, null);
      let group = data[date].series.find((series) => series.name === groupName);

      if (!group) {
        group = {
          name: groupName,
          value: 0,
        };
        data[date].series.push(group);
      }

      group.value += 1;
    });

    return this.accumulateResults(data);
  }

  private accumulateResults(data) {
    let accumulatedSeries = [];
    const dataValues = Object.values(data);

    dataValues.forEach((dataElem: any) => {
      if (!dataElem.series.length) {
        dataElem.series = accumulatedSeries;
        return;
      }
      accumulatedSeries = this.accumulate(dataElem, cloneDeep(accumulatedSeries));
      dataElem.series = accumulatedSeries;
    });

    return dataValues;
  }

  private accumulate({ series }, accumulatedSeries) {
    series.forEach((seriesElem) => {
      const group = accumulatedSeries.find((original) => original.name === seriesElem.name);
      if (group) {
        group.value = seriesElem.value + group.value;
      } else {
        accumulatedSeries.push({ value: seriesElem.value, name: seriesElem.name });
      }
    });
    return accumulatedSeries;
  }
}
